import { render, staticRenderFns } from "./ProcessMenu.vue?vue&type=template&id=1a469494&scoped=true&"
import script from "./ProcessMenu.vue?vue&type=script&lang=js&"
export * from "./ProcessMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a469494",
  null
  
)

export default component.exports